<script setup>
import { computed } from 'vue'
import { Link, usePage } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'
import { useBreakpoint } from '@/composables/useBreakpoint'

const { t } = useI18n()
const page = usePage()
const { isMobile } = useBreakpoint()
const isAdmin = computed(() => page.props.auth?.user?.role === 'admin')

const tabs = computed(() => {
  const list = [
    { key: 'users',         label: t('nav.users'),                  href: '/users' },
    { key: 'permissions',   label: t('nav.permissions'),            href: '/users/permissions' },
    { key: 'localization',  label: t('settings.tabs.localization'), href: '/settings?tab=localization' },
    { key: 'agreement',     label: t('settings.tabs.agreement'),    href: '/settings?tab=agreement' },
    { key: 'offices',       label: t('settings.tabs.offices'),      href: '/offices' },
    { key: 'rate_plans',    label: t('settings.tabs.ratePlans'),    href: '/rate_plans' },
    { key: 'appearance',    label: t('settings.tabs.appearance'),   href: '/settings?tab=appearance' },
    { key: 'quick_replies', label: t('quickReplies.title'),         href: '/quick_replies' },
  ]
  let filtered = list
  if (isMobile.value) filtered = filtered.filter(tab => tab.key !== 'appearance')
  if (!isAdmin.value) filtered = filtered.filter(tab => tab.key !== 'quick_replies')
  return filtered
})

const activeKey = computed(() => {
  const url = page.url
  if (url.startsWith('/users/permissions')) return 'permissions'
  if (url.startsWith('/users')) return 'users'
  if (url.startsWith('/offices')) return 'offices'
  if (url.startsWith('/rate_plans')) return 'rate_plans'
  if (url.startsWith('/quick_replies')) return 'quick_replies'
  if (url.startsWith('/settings')) {
    const match = url.match(/[?&]tab=([^&]+)/)
    const tab = match ? match[1] : 'localization'
    return ['localization', 'agreement', 'appearance'].includes(tab) ? tab : 'localization'
  }
  return null
})
</script>

<template>
  <div
    class="flex gap-1 overflow-x-auto overflow-y-hidden"
    :style="{ borderBottom: '1px solid var(--line)' }"
    role="tablist"
  >
    <Link
      v-for="tab in tabs"
      :key="tab.key"
      :href="tab.href"
      class="px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors whitespace-nowrap"
      :style="activeKey === tab.key
        ? { borderColor: 'var(--accent)', color: 'var(--ink)' }
        : { borderColor: 'transparent', color: 'var(--muted)' }"
      role="tab"
      :aria-selected="activeKey === tab.key"
    >
      {{ tab.label }}
    </Link>
  </div>
</template>
